"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var shopCarOrderApi = _interopRequireWildcard(require("@/api/shopCarOrderApi"));
var _ShopCarCardOrderDetail = _interopRequireDefault(require("./components/ShopCarCardOrderDetail.vue"));
var _FreezeParkingCardDialog = _interopRequireDefault(require("./components/FreezeParkingCardDialog.vue"));
var _DelayParkingCardDialog = _interopRequireDefault(require("./components/DelayParkingCardDialog.vue"));
var _UnfreezeParkingCardDialog = _interopRequireDefault(require("./components/UnfreezeParkingCardDialog.vue"));
function _interopRequireDefault(e) { return e && e.__esModule ? e : { default: e }; }
var cache;
function _interopRequireWildcard(e, t) { if (!t && e && e.__esModule) return e; var r, c, a = Object.defineProperty, n = { __proto__: null, default: e }; if (Object(e) !== e) return n; if (cache || "function" != typeof WeakMap || (cache = new WeakMap()), cache) { if (cache.has(e)) return cache.get(e); cache.set(e, n); } for (c in e) "default" !== c && {}.hasOwnProperty.call(e, c) && ((r = a && Object.getOwnPropertyDescriptor(e, c)) && (r.get || r.set) ? a(n, c, r) : n[c] = e[c]); return n; }
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
var _default = exports.default = {
  name: 'ShopCarCardList',
  components: {
    ShopCarCardOrderDetail: _ShopCarCardOrderDetail.default,
    FreezeParkingCardDialog: _FreezeParkingCardDialog.default,
    DelayParkingCardDialog: _DelayParkingCardDialog.default,
    UnfreezeParkingCardDialog: _UnfreezeParkingCardDialog.default
  },
  data: function data() {
    return {
      constants: this.$constants,
      listPram: {
        page: 1,
        limit: this.$constants.page.limit[0],
        orderNo: '',
        productName: '',
        phone: '',
        plateNo: '',
        parkName: '',
        orderStatus: '',
        expireStartTime: '',
        expireEndTime: '',
        orderStartTime: '',
        orderEndTime: ''
      },
      listData: {
        list: [],
        total: 0
      },
      listLoading: false,
      expireDateRange: [],
      orderDateRange: [],
      orderStatusOptions: [{
        label: '全部',
        value: ''
      }, {
        label: '待支付',
        value: 1
      }, {
        label: '已完成',
        value: 2
      }, {
        label: '已取消',
        value: 3
      }, {
        label: '订单异常',
        value: 4
      }]
    };
  },
  mounted: function mounted() {
    this.handlerGetListData();
  },
  computed: {
    parkingCardPermissions: function parkingCardPermissions() {
      var permissions = this.$store.getters && this.$store.getters.permissions || [];
      var hasAllPermission = permissions.includes('*:*:*');
      return {
        freeze: hasAllPermission || permissions.includes('admin:order:parking-card:freeze'),
        unfreeze: hasAllPermission || permissions.includes('admin:order:parking-card:unfreeze'),
        extend: hasAllPermission || permissions.includes('admin:order:parking-card:extend')
      };
    }
  },
  methods: {
    handleExpireDateChange: function handleExpireDateChange(val) {
      if (Array.isArray(val) && val.length === 2) {
        this.listPram.expireStartTime = val[0];
        this.listPram.expireEndTime = val[1];
      } else {
        this.listPram.expireStartTime = '';
        this.listPram.expireEndTime = '';
      }
    },
    handleOrderDateChange: function handleOrderDateChange(val) {
      if (Array.isArray(val) && val.length === 2) {
        this.listPram.orderStartTime = val[0];
        this.listPram.orderEndTime = val[1];
      } else {
        this.listPram.orderStartTime = '';
        this.listPram.orderEndTime = '';
      }
    },
    handerSearch: function handerSearch() {
      this.listPram.page = 1;
      this.handlerGetListData();
    },
    handleReset: function handleReset() {
      this.listPram = {
        page: 1,
        limit: this.$constants.page.limit[0],
        orderNo: '',
        productName: '',
        phone: '',
        plateNo: '',
        parkName: '',
        orderStatus: '',
        expireStartTime: '',
        expireEndTime: '',
        orderStartTime: '',
        orderEndTime: ''
      };
      this.expireDateRange = [];
      this.orderDateRange = [];
      this.handlerGetListData();
    },
    handlerGetListData: function handlerGetListData() {
      var _this = this;
      this.listLoading = true;
      shopCarOrderApi.getParkingCardOrderList(this.listPram).then(function (res) {
        _this.listData = {
          list: res && Array.isArray(res.list) ? res.list : [],
          total: res && Number(res.total) ? Number(res.total) : 0
        };
        _this.listLoading = false;
      }).catch(function () {
        _this.listData = {
          list: [],
          total: 0
        };
        _this.listLoading = false;
      });
    },
    handleSizeChange: function handleSizeChange(val) {
      this.listPram.limit = val;
      this.handlerGetListData();
    },
    handleCurrentChange: function handleCurrentChange(val) {
      this.listPram.page = val;
      this.handlerGetListData();
    },
    openOrderDetail: function openOrderDetail(row) {
      if (!row || !row.orderNo) {
        this.$message.warning('订单编号缺失');
        return;
      }
      if (this.$refs.shopCarCardOrderDetailRef) {
        this.$refs.shopCarCardOrderDetailRef.open(row.orderNo, row);
      }
    },
    handleFreeze: function handleFreeze(row) {
      if (this.$refs.freezeParkingCardDialog) {
        this.$refs.freezeParkingCardDialog.open(row);
      }
    },
    handleDelay: function handleDelay(row) {
      if (this.$refs.delayParkingCardDialog) {
        this.$refs.delayParkingCardDialog.open(row);
      }
    },
    handleUnfreeze: function handleUnfreeze(row) {
      if (this.$refs.unfreezeParkingCardDialog) {
        this.$refs.unfreezeParkingCardDialog.open(row);
      }
    }
  }
};